import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import TrackingNow from "./components/TrackingNow";
import LatestUpdates from "./components/LatestUpdates";
import CategoryGrid from "./components/CategoryGrid";
import PrinciplesBand from "./components/PrinciplesBand";
import TipsSection from "./components/TipsSection";
import FaqPreview from "./components/FaqPreview";

export default function Home() {
  const location = useLocation();

  useSeo({
    title: "爆料网上 - 事件真相与始末追踪，热点事件进展盘点",
    description:
      "爆料网上专注热点事件始末追踪与后续进展盘点，从事件发生、舆情发酵到回应反转，按时间线梳理关键节点，帮助读者一次看清事件真相与全貌。",
    keywords: "爆料网上,爆料网上事件,爆料网上事件真相,爆料网上事件进展,爆料网上事件盘点",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "爆料网上",
        url: "https://huahuoyouxi.cn/",
        description: "专注热点事件始末追踪与后续进展盘点，按时间线梳理关键节点。",
        email: "tips@baoliao-web.cn",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "爆料网上",
        url: "https://huahuoyouxi.cn/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://huahuoyouxi.cn/events?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
    ],
  });

  useEffect(() => {
    if (location.hash === "#tips") {
      const el = document.getElementById("tips");
      if (el) {
        window.setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
      }
    }
  }, [location]);

  return (
    <>
      <Hero />
      <TrackingNow />
      <LatestUpdates />
      <CategoryGrid />
      <PrinciplesBand />
      <TipsSection />
      <FaqPreview />
    </>
  );
}